var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from 'mobx';
import { serializable } from 'serializr';
import storage from '../storage';
export default class SettingsStore {
    constructor() {
        this.isOpen = false;
        this.nightMode = false;
        this.strictMode = true;
    }
    open() {
        this.isOpen = true;
    }
    close() {
        this.isOpen = false;
    }
    clear() {
        storage.clear().then(() => window.location.reload(false));
    }
}
SettingsStore.NIGHT_MODE = 'night-mode';
__decorate([
    observable,
    __metadata("design:type", Boolean)
], SettingsStore.prototype, "isOpen", void 0);
__decorate([
    observable, serializable,
    __metadata("design:type", Boolean)
], SettingsStore.prototype, "nightMode", void 0);
__decorate([
    observable, serializable,
    __metadata("design:type", Boolean)
], SettingsStore.prototype, "strictMode", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SettingsStore.prototype, "open", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SettingsStore.prototype, "close", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SettingsStore.prototype, "clear", null);
